import { render, staticRenderFns } from "./TransactionEgresosTab.vue?vue&type=template&id=28989aac"
import script from "./TransactionEgresosTab.vue?vue&type=script&lang=js"
export * from "./TransactionEgresosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports